// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 3007 ? "ProjectClientPage" : chunkId) + "." + {"3007":"dafdae52","8418":"feac635a"}[chunkId] + ".chunk.css";
};